import { default as submitCaseHandlers } from './handlers/submit-case.handlers';
import { default as versionHandlers } from './handlers/version.handlers';

export const handlers = [...versionHandlers, ...submitCaseHandlers];
